import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import MainNavigation from "./Navigation/MainNavigation";
import SignInContainer from "../containers/SignInContainer/SignInContainer";
import Container from "./Common/Container";
import { selectEstateListStatus } from "../modules/estate/estateList/estateListSlice";
import PageLoader from "./Common/PageLoader";
import { REQUEST_STATUS } from "../functions/constants";
// import { propertyManagementSelectors } from "../modules/propertyManagement/propertyManagementSlice";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const sessionToken = useSelector((state) => state.sessionToken);
  // We need at least one estate to render the protected route.

  // const propertyManagement = useSelector(
  //   propertyManagementSelectors.selectPropertyManagement,
  // );
  const estateListStatus = useSelector(selectEstateListStatus);

  const appIsLoading = estateListStatus === REQUEST_STATUS.LOADING;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!sessionToken) {
          return (
            <Redirect
              to={{
                pathname: SignInContainer.route,
                from: props.location,
              }}
            />
          );
        }

        return appIsLoading ? (
          <PageLoader />
        ) : estateListStatus === REQUEST_STATUS.FAILED ? (
          <div>Error loading estates. Please try again later.</div>
        ) : (
          <React.Fragment>
            <Container>
              <Component {...props} />
            </Container>
            {/* main navigation */}
            <MainNavigation {...props} />
          </React.Fragment>
        );
      }}
    />
  );
};

export default withRouter(ProtectedRoute);
